import { getLang } from 'mailup-react-helpers'
import { createIntl, createIntlCache } from 'react-intl'
import messages from '../i18n/messages.json'

let intlInstance = null

/**
 * @returns standalone intl utility
 *
 */
const getIntl = () => {
  if (!intlInstance) {
    const l = getLang()
    const cache = createIntlCache()
    intlInstance = createIntl({ messages: messages[l], locale: l }, cache)
  }
  return intlInstance
}

export default getIntl
